import { Button, Icons, Modal, useModal } from "@pankod/refine-antd";
import { HistoryTab } from "components/common/historyTab";
import { IStateManager } from "interfaces";

export declare type TimeLineProps =
    {
        stateManager: IStateManager,
        mode?: "standard" | "worklist";
    }

export const RenderTimelineModal: React.FC<TimeLineProps> = ({ stateManager, mode = "standard" }) => {
    const { modalProps, show, close } = useModal()

    return (
        <>
            {mode === "worklist" ?
                <div className="st-btn-dv" onClick={show}>
                    <Icons.HistoryOutlined /> History
                </div>
                :
                <Button onClick={show} icon={<Icons.HistoryOutlined />}>History</Button>
            }
            <Modal
                {...modalProps}
                footer={
                    <Button type="primary" key="back" onClick={close}>
                        Return
                    </Button>
                }
                width='80%'
            >
                <HistoryTab
                    stateManager={stateManager}
                    tabPosition={'top'}
                    modalView={true}
                />
            </Modal>
        </>
    );
};